import { StorageAdapter } from '@record-it-npm/synchro-client';
import { KeyValueStorage } from 'record-it-utils/dataStorage/KeyValueStorage';

export function initStorageAdapter(): void {
  StorageAdapter.configure({
    getEntities: (entityName) => {
      return KeyValueStorage.getItems(entityName);
    },
    setEntities: (entities, entityName) => {
      return KeyValueStorage.setItems(
        entities.map((e) => ({ key: e.id, value: e })),
        entityName
      );
    },
    removeEntities: (ids, entityName) => {
      return KeyValueStorage.removeItems(ids, entityName);
    },
    getGeneralItem: (key) => {
      return KeyValueStorage.getItem(key, 'entityManager');
    },
    setGeneralItem: (key, value) => {
      return KeyValueStorage.setItem(key, value, 'entityManager');
    },
    removeGeneralItem: (key) => {
      return KeyValueStorage.removeItem(key, 'entityManager');
    }
  });
}
